<template>
    <div class="tags are-large is-centered">
        <span class="tag is-primary">
            <span class="icon">
                <i class="fa fa-user"></i>
            </span>
            <span> {{ users }}</span>
        </span>

        <span class="tag is-primary">
            <span class="icon">
                <i class="fa fa-envelope" />
            </span>
            <span>
                {{ emails }}
            </span>
        </span>

        <span class="tag is-primary">
            <span class="icon">
                <i class="fas fa-mobile-alt"></i>
            </span>
            <span>
                {{ phones }}
            </span>
        </span>
    </div>
</template>

<script>
    export default {
        name: "receivers-summary",
        props: ["users", "emails", "phones"],
    };
</script>

<style scoped></style>
